import React, { Component } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Sidebar from "./components/sidebar";
import Introduction from "./components/introduction";
import About from "./components/about";
import ServicesWithRouter from "./components/servicewithrouter";
import Reviews from "./components/reviews";
import Project from "./components/projects";
import Blog from "./components/blog";
import Certificates from "./components/certificates";
import Footer from "./components/footer";
import Skills from "./components/skills";
import OtherWorkGallery from "./components/othergallery";
import Contact from "./components/contact";
import Broshure from "./components/broshure";
import ServiceShowcasePage from "./components/serviceshowpage";
import ScrollToHash from "./components/scrolltohash";
import SidebarWithRouter from "./components/sidebarwithrouter";
class App extends Component {
  render() {
    return (
      <Router>
        <div id="colorlib-page">
          <div id="container-wrap">
            <SidebarWithRouter />
            <div id="colorlib-main">
              <Routes>
                <Route
                  path="/"
                  element={
                    <>
                      <ScrollToHash />
                      <Introduction />
                      <About />
                      <Broshure />
                      <ServicesWithRouter />
                      <Skills />
                      <OtherWorkGallery />
                      <Certificates />
                      <Project />
                      <Reviews />
                      <Contact />
                      <Footer />
                    </>
                  }
                />
                <Route
                  path="/service/:slug"
                  element={<ServiceShowcasePage />}
                />
              </Routes>
            </div>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
